import PropTypes from 'prop-types';
import React from 'react';
import DrawerContext from './context';

export default class DrawerProvider extends React.Component {
  constructor(props) {
    super(props);
    this.registerToggle = (name, toggle) => {
      this.setState(prevState => ({
        togglers: Object.assign(prevState.togglers, {
          [name]: toggle
        })
      }), () => {
      });
    };

    this.registerToggle = this.registerToggle.bind(this);

    this.state = {
      togglers: {},
      registerToggle: this.registerToggle,
      toggle: name => {
        const toggle = this.state.togglers[name];
        if (toggle) {
          toggle();
        }
      }
    };
  }

  render() {
    return (
      <DrawerContext.Provider
        value={{
          toggle: this.state.toggle,
          registerToggle: this.state.registerToggle
        }}
      >
        {this.props.children}
      </DrawerContext.Provider>
    );
  }
}

DrawerProvider.propTypes = {
  children: PropTypes.node
};
